import { useQuery } from '@tanstack/react-query';
import publicAxiosInstance from '../../../constants/publicAxiosInstance';
import { InsightDetails } from '../types/InsightsType';

interface PublicInsightDetailsResponse {
  message?: string;
  data: InsightDetails;
}

const fetchPublicInsightDetails = async (insightId: string): Promise<InsightDetails> => {
  const { data } = await publicAxiosInstance().get<PublicInsightDetailsResponse>(
    `/deeplinks/getInsightDetails?insightId=${insightId}`
  );
  return data?.data;
};

export const usePublicInsightDetails = (insightId: string, enabled: boolean = true) => {
  const {
    data: insightDetails,
    isLoading: isInsightDetailsLoading,
    error: insightDetailsError,
    refetch: refetchInsightDetails,
  } = useQuery({
    queryKey: ['publicInsightDetails', insightId],
    queryFn: () => fetchPublicInsightDetails(insightId),
    enabled: enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    insightDetails,
    isInsightDetailsLoading,
    insightDetailsError,
    refetchInsightDetails,
  };
};

